import CryptoJS from 'crypto-js';
export enum SiteId {
  ApiCafe = 'api-cafe',
  BankApi = 'bank-api',
  Directory = 'directory',
  DakkoHub = 'dakkohub',
  Obd = 'openbankingdirectory',
}

const env = {
  siteName: process.env.REACT_APP_SITE_NAME ?? '',
  siteId: process.env.REACT_APP_SITE_ID ?? '',
  // siteId: SiteId.Obd,
  domain: process.env.REACT_APP_DOMAIN_NAME ?? '',
  rootUrl: process.env.REACT_APP_ROOT_URL ?? '',
  apiCafeDomain: process.env.REACT_APP_APICAFE_DOMAIN_NAME ?? 'apicafe.io',
  bankApiDomain: process.env.REACT_APP_BANKAPI_DOMAIN_NAME ?? 'bank-api.net',
  obdDomain: process.env.REACT_APP_OBD_DOMAIN_NAME ?? 'openbankingdirectory.io',
  dakkoHubDomain: process.env.REACT_APP_DAKKO_HUB_DOMAIN_NAME ?? 'dakkohub.health',
  supportEmail: 'hello@openbankingdirectory.io',
  ga: {
    mainTrackingCode: process.env.REACT_APP_GA_TRACKING_CODE ?? '',
    adsTrackingCode: process.env.REACT_APP_GA_ADS_TRACKING_CODE ?? '',
  },
  api: {
    baseUrl: {
      sharingService: process.env.REACT_APP_SHARING_SERVICE_BASE_URL ?? '',
      token: process.env.REACT_APP_TOKEN_BASE_URL ?? '',
      identityService: process.env.REACT_APP_IDENTITY_SERVICE_BASE_URL ?? '',
      serviceDirectory: process.env.REACT_APP_SERVICE_DIRECTORY_BASE_URL ?? '',
      countryInformation: process.env.REACT_APP_COUNTRY_INFORMATION_BASE_URL ?? '',
      staticAssets: process.env.REACT_APP_STATIC_ASSETS_BASE_URL ?? '',
      membership: process.env.REACT_APP_MEMBERSHIP_SERVICE_BASE_URL ?? '',
    },
    cK: process.env.REACT_APP_CI
      ? CryptoJS.AES.decrypt(process.env.REACT_APP_CI, 'OBD').toString(CryptoJS.enc.Utf8)
      : '',
    cS: process.env.REACT_APP_CS
      ? CryptoJS.AES.decrypt(process.env.REACT_APP_CS, 'OBD').toString(CryptoJS.enc.Utf8)
      : '',
    tenantDomain: process.env.REACT_APP_TENANT_DOMAIN ?? '',
  },
  cookie: {
    domain: process.env.REACT_APP_COOKIE_DOMAIN ?? '',
  },
  dev: {
    subdomain: process.env.REACT_APP_DEV_SUBDOMAIN ?? '',
    // subdomain: 'testing-bank',
  },
  socials: {
    firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? '',
    firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? '',
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '',
    googleClientSecret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET ?? '',
    facebookAppID: process.env.REACT_APP_FACEBOOK_APP_ID ?? '',
    linkedinClientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID ?? '',
    linkedinClientSecret: process.env.REACT_APP_LINKEDIN_CLIENT_SECRET ?? '',
    linkedinCallBack: process.env.REACT_APP_LINKEDIN_CALLBACK_URL ?? '',
    oauthBaseUrlLinkedin: 'https://www.linkedin.com/oauth/v2',
  },
  roles: {
    apiPublisher: 'ApiPublisher',
    bankAdmin: 'BankAdmin',
    directoryAdmin: 'DirectoryAdmin',
    superAdmin: 'SuperAdmin',
    organisationOwner: 'OrganisationOwner',
  },
  map: {
    googleClientKey: process.env.REACT_APP_GOOGLE_CLIENT_KEY ?? '',
  },
  color: {
    primaryColor: process.env.REACT_APP_PRIMARY_COLOR ?? '#0174e3',
  },
  facebookID: '394597934930152',
  zendesk: {
    key: process.env.REACT_APP_ZENDESK_KEY,
  },
  google: {
    recaptchaKey: process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY ?? '',
    recaptchaEnable: process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLE
      ? process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLE === 'true'
      : false,
  },
  cookieControl: {
    apiKey: process.env.REACT_APP_COOKIE_CONTROL_API_KEY ?? '',
  },
  nonceValue: '8cQWMsPL0s4CPs5gycOg',
};

export default env;
